import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from './modules/app';
import { IUserState } from './modules/user';
import { ITagsViewState } from './modules/tagsView';
import { IPermissionState } from './modules/permission';


Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  user: IUserState;
  tagsView: ITagsViewState;
  permission: IPermissionState;
}

// 先声明空的，后面动态注册进去
export default new Vuex.Store<IRootState>({});
